<script setup>

import { defineProps, defineEmits} from "vue";
import LinhasDoPagamentoTabela from "./LinhasDoPagamento/LinhasDoPagamentoTabela.vue"
import LinhasDoPagamentoDePensaoAlimenticiaTabela from "./LinhasDoPagamentoDePensaoAlimenticia/LinhasDoPagamentoDePensaoAlimenticiaTabela.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pagamentoEletronico",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:pagamentoEletronico",
    "update:justificativa"
]);


//==================================================================//
//=============== Altera Pagamento Eletronico ======================//
//==================================================================//

const alteraPagamentoEletronico = (update={})=>{

    emits('update:pagamentoEletronico',update);

};


//==================================================================//
//====================== Altera Justificativa ======================//
//==================================================================//

const alteraJustificativa = (update={})=>{

    emits('update:justificativa',update);

};

</script>

<template>

    <div class="c-conteudo">

        <LinhasDoPagamentoDePensaoAlimenticiaTabela
            v-if="props?.pagamentoEletronico?.sigla == 'PEPA'"
            :pagamentoEletronico="props.pagamentoEletronico"
        >
        </LinhasDoPagamentoDePensaoAlimenticiaTabela> 

        <LinhasDoPagamentoTabela
            v-else
            :pagamentoEletronico="props.pagamentoEletronico"
        >
        </LinhasDoPagamentoTabela> 

    </div>

</template>

<style scoped>

.c-conteudo{
    display: grid;
    gap: 15px;
}

</style>